// @flow

export async function fetchIsUserLoggedInData(): Promise<boolean> {
  const data = await (await window.fetch(`/wishlist/user/isloggedin`)).json();

  return data.isLoggedIn;
}
